module.exports = __webpack_public_path__ + "img/cust_reports_icon.a285c29a.svg";